import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Util } from '../util.service';

@Injectable({
  providedIn: 'root'
})
export class DifficultymodifiersService {
  baseurl = Util.GetBaseUrl();

  constructor(private http: HttpClient, public router: Router) { }

  viewModifier() {
    return this.http.get(this.baseurl + '/api/DiffcultyModifiers/GetModifiers')
  }

  addModifier(Form) {
    console.log(Form);
    return this.http.post(this.baseurl + '/api/DiffcultyModifiers', Form)
  }

  editModifier(id, Form) {
    console.log(id);
    return this.http.put(this.baseurl + `/api/DiffcultyModifiers/${id}`, Form)
  }

  deleteModifier(id) {
    console.log(id);
    return this.http.delete(this.baseurl + `/api/DiffcultyModifiers/${id}`)
  }
}
